import React from "react";
import { useAppContext } from "../../AppProvider";
import { ShipmentCost } from "../../Models/ShipmentCost";

export const ShipmentCostsListItem: React.FC<{
  listRef: React.RefObject<{
    refresh: () => void;
  } | null>;
  item: ShipmentCost;
  index: number;
}> = React.memo(({ item }) => {
  const { dictionary } = useAppContext();

  return (
    <>
      <div className="d-flex justify-content-between">
        <label className="label-2 pt-2">{item.name}:</label>
        <div className="row w-50 text-center ">
          <div
            className="col-6 pt-2 "
            style={{ borderRight: "1px solid #c7c9cd" }}
          >
            <label className={`label-2 ${item.value === 0 && "text-success"}`}>
              {item.value && item.value !== 0
                ? `${item.value.toFixed(2)} € `
                : dictionary.words.free}
            </label>
          </div>
          <div className="col-6 pt-2">
            <label className="label-2">
              {item.time ? `${item.time} h ` : "-"}
            </label>
          </div>
        </div>
      </div>
    </>
  );
});
